import { render } from "./ConfirmEmail.vue?vue&type=template&id=b2b53f2c&ts=true"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__